import { z } from "zod";
import { CommunicationChannel } from "./communication-channel.schemas.js";
import { EmailAddressSchema } from "./email.schemas.js";
import { WhatsAppIdSchema } from "./whatsapp-id.schemas.js";

export const WhatsAppAllowedCommunicationChannelSchema = z.object({
  channel: z.literal(CommunicationChannel.WHATSAPP),
  identifier: WhatsAppIdSchema,
});
export const EmailAllowedCommunicationChannelSchema = z.object({
  channel: z.literal(CommunicationChannel.EMAIL),
  identifier: EmailAddressSchema,
});
export const EventAllowedCommunicationChannelSchema = z.discriminatedUnion(
  "channel",
  [
    WhatsAppAllowedCommunicationChannelSchema,
    EmailAllowedCommunicationChannelSchema,
  ],
);

export type EventAllowedCommunicationChannel = z.infer<
  typeof EventAllowedCommunicationChannelSchema
>;
